import { render, staticRenderFns } from "./mobile-sub-nav.vue?vue&type=template&id=efb03d1e&scoped=true&"
import script from "./mobile-sub-nav.vue?vue&type=script&lang=js&"
export * from "./mobile-sub-nav.vue?vue&type=script&lang=js&"
import style0 from "./mobile-sub-nav.vue?vue&type=style&index=0&id=efb03d1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb03d1e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
